import { take, call, fork, takeEvery } from 'redux-saga/effects';
import { postContentLoaded, postContentResized, postScrollToTop } from '../../services/iframe';
import { reservationPlacedSaga, reservationFailedSaga } from './task';

import * as Constants from '../../actions';

export function* actionHandler() {
    // takeEvery is non-blocking
    yield takeEvery(Constants.CONTENT_UPDATED, postContentResized)
    yield takeEvery(Constants.RESERVATION_PLACED, reservationPlacedSaga)
    yield takeEvery(Constants.RESERVATION_FAILED, reservationFailedSaga)
    yield takeEvery(Constants.SCROLL_TO_TOP, postScrollToTop)
};

function* iframeSaga() {
    yield take(Constants.CONTENT_LOADED)
    yield call(postContentLoaded)
    yield fork(actionHandler)
    // yield fork(contentResizedSaga)
}

export default iframeSaga


// WEBPACK FOOTER //
// ./src/sagas/iframe/index.js